if (!customElements.get('bt-search-reference')) {
  customElements.define('bt-search-reference', class extends HTMLElement {
    async connectedCallback() {
      const query = this.dataset.query || '';
      const references = [...query.matchAll(/(?:^|\D)(\d{5})(?!\d)/g)].map((match) => match[1]);
      if (references.length !== 1) return;

      const controller = new AbortController();
      this.abortLookup = () => controller.abort();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const endpoint = new URL(`${root}search/suggest.json`, window.location.origin);
        endpoint.searchParams.set('q', `variants.sku:66${references[0]}*`);
        endpoint.searchParams.set('resources[type]', 'product');
        endpoint.searchParams.set('resources[limit]', '3');
        endpoint.searchParams.set('resources[options][fields]', 'variants.sku');

        const response = await fetch(endpoint, { signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        if (!this.isConnected) return;

        const matches = (data.resources?.results?.products || []).filter((product) =>
          product.vendor?.toLowerCase() === 'lego' && product.title && product.url
        );
        if (matches.length !== 1) return;

        const product = matches[0];
        const productUrl = new URL(product.url, window.location.origin);
        if (productUrl.origin !== window.location.origin || !productUrl.pathname.includes('/products/')) return;

        const firstResult = this.closest('.template-search')?.querySelector('.grid__item a[href*="/products/"]');
        if (firstResult && new URL(firstResult.href, window.location.origin).pathname === productUrl.pathname) return;

        this.querySelector('.bt-search-reference__link').textContent = product.title;
        this.querySelectorAll('a').forEach((link) => { link.href = productUrl.pathname; });
        this.hidden = false;

        const noResultsHero = this.closest('.template-search')?.querySelector('.bt-search-hero--no-results');
        if (noResultsHero) {
          noResultsHero.querySelector('h1').textContent = this.dataset.foundHeading;
          noResultsHero.querySelector('.bt-search-hero__intro').textContent = this.dataset.foundIntro;
          this.closest('.template-search').querySelector('.bt-search-recovery')?.setAttribute('hidden', '');
        }
      } catch (error) {
        if (error.name !== 'AbortError') console.debug('LEGO reference lookup unavailable', error);
      }
    }

    disconnectedCallback() {
      this.abortLookup?.();
    }
  });
}
